import { TournamentType } from '@okletsplay/core';
import get from 'lodash/get';
import { mixed, ObjectSchema, TestContext } from 'yup';
import { DOUBLE_ELIMINATION_MIN_TEAM_MINIMUM_VALUE } from 'app/constants';

interface TestContextExtended {
  from: {
    schema: ObjectSchema<never>;
    value: unknown;
  }[];
}

export const BASE_MIN_TEAMS_VALIDATION_SHAPE = mixed().test({
  name: 'minTeams',
  message: 'Min teams must be less than or equal to max teams.',
  test: function (value: number) {
    const { from } = this as TestContext & TestContextExtended;
    const eliminationFormat = get(from, '[1].value.matchSetupSettings.eliminationFormat');

    if (eliminationFormat !== TournamentType.DoubleEliminationTournament) {
      return value <= this.parent.maxTeams;
    }

    if (value > this.parent.maxTeams) {
      return false;
    }

    if (
      value < DOUBLE_ELIMINATION_MIN_TEAM_MINIMUM_VALUE &&
      eliminationFormat === TournamentType.DoubleEliminationTournament
    ) {
      return this.createError({
        message: `Min team must be greater or equal to ${DOUBLE_ELIMINATION_MIN_TEAM_MINIMUM_VALUE} for double elimination`,
      });
    }

    return true;
  },
});
